import NZTutaraOption from "../../../components/NZComponent/home/NZTutaraOption/nZTutaraOption";
import NZUltra from "../../../components/NZComponent/home/NZUltra/NZUltra";
import NZYouTube from "../../../components/NZComponent/home/NZYouTube/nZYouTube";
import NZBanner from "../../../components/NZComponent/home/banner";
import CardDownImg from "../../../assets/svg/nz-bg-card-down.svg";
import CardUpImg from "../../../assets/svg/nz-bg-card-up.svg";
import CardUpImgDark from "../../../assets/svg/nz-bg-card-up-dark.svg";

import Bg1 from "../../../assets/images/Tuatara-1000-Central-Otago.jpeg";
import Bg2 from "../../../assets/images/Tuatara-in-the-bg.webp";
import NZShipping from "../../../components/NZComponent/home/NZShipping/NZShipping";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";

const HomePage = () => {
  return (
    <>
      <NZBanner />
      <NZTutaraOption />
      <NZYouTube />

      <div>
        <div>
          {/* Part One */}
          <div className="w-full bg-fixed bg-cover bg-center" style={{ backgroundImage: `url(${Bg1})` }}>
            {" "}
            <div className="w-full flex items-center justify-center">
              <div className="text-white kuunari-bold lg:text-[106px] md:text-[80px] text-[50px] leading-[68px] lg:py-[190px] md:py-[100px] py-[80px]">
                The Go Anywhere UTV !
              </div>
            </div>
            <img src={CardUpImg} className="w-full" />
            <NZUltra />
          </div>

          {/* Part Two */}
          <div
            className="w-full bg-fixed bg-cover bg-center"
            style={{ backgroundImage: `url(${Bg2})`, backgroundPosition: "top" }}
          >
            <img src={CardDownImg} className="w-full" />
            <div className="w-full flex items-center justify-center">
              <div className="text-white kuunari-bold lg:text-[106px] md:text-[80px] text-[50px] leading-[68px] lg:py-[190px] md:py-[100px] py-[80px]">
                100% ADVENTURE
              </div>
            </div>
            <img src={CardUpImgDark} className="w-full" />
          </div>
        </div>
      </div>
      <div>
        <NZShipping />
      </div>
      <div>
        <NZGregFarrier />

        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default HomePage;
